<template>
  <label :id="`${props.for}-label`" :for="props.for" :class="theme.text" class="modern-color-theme font-poppins leading-6 flex items-center" data-component-name="VSLabel">
    <slot />
    <VIcon v-if="props.tooltip" color="neutral" size="xs" name="Outline/information-circle" class="ml-1 cursor-pointer" :title="props.tooltip" />
  </label>
</template>
<script setup lang="ts">
import VIcon from '@component-library/labels/VIcon.vue';
import type { ThemeProp } from '@component-library/themes';
import { useTheme } from './VSLabel.theme';

const props = defineProps<{
  for: string
  tooltip?: string
  theme?: ThemeProp<typeof useTheme>
}>()

const theme = useTheme(props)

defineOptions({
  name: 'VSLabel'
})
</script>